import { TrialCompanyListPage } from "@/features/company/pages/TrialCompanyList";
import React from "react";

const TrialCompanyList = () => {
  return <TrialCompanyListPage />;
};

export default TrialCompanyList;
